export default __webpack_public_path__ + "static/media/050_brake_02.4e96398b.mp3";